import React from 'react';
import PropTypes from 'prop-types';
import BtnUpdate from '../common/BtnUpdate';
import SelectKikanNew from '../common/SelectKikanNew';
import SelectKubun from '../common/SelectKubun';
import SwitchKyujitsuHyoji from '../common/SwitchKyujitsuHyoji';
import SelectPSKubun from '../common/SelectPSKubun';
import SelectRate from '../common/SelectRate';
import SelectKaishibiNew from '../common/SelectKaishibiNew';
import SelectType from '../common/SelectType';
import SelectMaker from '../common/SelectMaker';
import SearchKishuName from '../common/SearchKishuName';
import SelectGouki from '../common/SelectGouki';
import SelectGoukiKotei from '../common/SelectGoukiKotei';
import SelectYugiType from '../common/SelectYugiType';
import SelectYugiTypeKotei from '../common/SelectYugiTypeKotei';
import * as defaultValue from '../../../constants/common/ConstDefaultValue';
import SelectSmartYugiki from '../common/SelectSmartYugiki';

/**
 * FilterForm
 */
class FilterForm extends React.Component {

  // 詳細設定用に追加
  constructor(props) {
    super(props);
    this.state = {
      isAccordionOpen: false,
    };
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  // 詳細設定用に追加
  toggleAccordion() {
    this.setState(prevState => ({
      isAccordionOpen: !prevState.isAccordionOpen
    }));
  }

  render() {
    const { isAccordionOpen } = this.state;
    let selectGouki = '';
    if (this.props.data.pskubun == defaultValue.PS_SLOT) {
      selectGouki = <SelectGouki actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />;
    } else {
      selectGouki = <SelectGoukiKotei />;
    }

    let selectYugiType = '';
    if (this.props.data.pskubun == defaultValue.PS_PACHINKO) {
      selectYugiType = <SelectYugiType actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />;
    } else {
      selectYugiType = <SelectYugiTypeKotei />;
    }

    return (
      <div className="fix_height dispfilter" id="filter_form">
        <div id="content_overlay_view" />
        <div className="ctrl_form_title2">
          <div className="ctrl_form_title_left">
            絞り込み条件
          </div>
          <div className="ctrl_form_title_right">
            <BtnUpdate actions={this.props.actions} />
          </div>
        </div>
        <div id="filter_form_area">
          <div id="filter_form_area_overlay_view" />
          <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
            <p>パチンコ・スロット＆レート</p>
          </div>
          <div className="flex-container">
            {/* パチンコ・スロット */}
            <SelectPSKubun actions={this.props.actions} data={this.props.data} isReadOnly={false} />
            {/* レート */}
            <SelectRate actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} isReadOnly={false} />
          </div>
          <SelectKikanNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />

          <SelectMaker actions={this.props.actions} data={this.props.data} />{/* メーカー */}
          <SelectKubun actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} /> {/* 地域・区分 */}
          <SelectType actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />{/* タイプ */}
          <SelectKaishibiNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />{/* 納品開始日 */}
          <SearchKishuName actions={this.props.actions} data={this.props.data} /> {/* 機種名検索 */}
          <div className="detail_settings">
            <div className="detail_settings_header" onClick={this.toggleAccordion} style={{ display: isAccordionOpen ? 'none' : 'block' }}>
              詳細設定
              <span>
                <span className="icon-spacing-left">
                  <i className="arrow_down" aria-hidden="true" />
                </span>
              </span>
            </div>
            <div className={`detail_settings_content ${isAccordionOpen ? 'open' : ''}`}>
              <SwitchKyujitsuHyoji actions={this.props.actions} data={this.props.data} />
              {selectGouki}{/* 号機 */}
              {selectYugiType}{/* 遊技タイプ */}
              <SelectSmartYugiki actions={this.props.actions} data={this.props.data} /> {/* スマート遊技機 */}
            </div>
            {isAccordionOpen && (
              <div className="detail_close" onClick={this.toggleAccordion}>
                閉じる
                <span>
                  <span className="icon-spacing-left">
                    <i className="arrow_up" aria-hidden="true" />
                  </span>
                </span>
              </div>
            )}
          </div>
        </div>
        {/* 閉じるボタンのコンテナを追加 */}
        <div className="filter-close-btn" id="filter_close_btn">
          <a className="btn sort_extraction js_pw" href="#pw_extraction" id="filter_form_btn">
            <div>
              <span>
                <i className="arrow_right" aria-hidden="true" />
              </span>
            </div>
            閉じる
          </a>
        </div>
      </div>
    );
  }
}

FilterForm.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default FilterForm;
